export default __webpack_public_path__ + "media/images/slider/top-6ba232b825571a5f4f67de00858fda69.png";